<template>
  <!-- style="height: 100vh; width: 100vw" -->
    <router-view/>
</template>
<script>
import { defineComponent, watch } from 'vue'
import { useQuasar } from 'quasar'
import { useStore } from '@/composables/store/useStore.js'
export default defineComponent({
  name: 'App',
  components: {
  },
  setup (props, context) {
    const $q = useQuasar()
    const store = useStore()

    watch(() => store.getDark, (value) => {
      $q.dark.set(value)
    }, { immediate: true })
  }
})
</script>
